module.exports = __webpack_public_path__ + "6c4a0dbc/img/note-edit-icon.acae1669.svg";